import React, { Component } from 'react';
import {
  Circle,
  Map,
  Marker,
  Polygon,
  Popup,
  TileLayer,
  Tooltip
} from 'react-leaflet';
import freguesiasGEOJSON from '../../data/freguesiasGEOJSON.json';
import './map.css'; //old map dependencies from OC - also Homescreen
import './map_bipzip.css';

import { useShallowEqual } from 'shouldcomponentupdate-children';

var Turf = require('@turf/turf');

class _Map extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedAmenity: 'school',
      map: null,
      tileLayer: null,
      geojsonLayer: null,
      loadingDataOnMap: false,
      geojson: [],
      paths: null,

      assetsOnMap: [],
      assetsActivatedArray: [],
      filteredGeojson: '*',
      numEntrances: null,
      points: null,
      lat: 38.722252,
      lng: -9.139337,
      zoom: 12
    };

    this.omg = this.omg.bind(this);
  }

  componentWillUnmount() {
    // code to run just before unmounting the component
    // this destroys the Leaflet map object & related event listeners
    if (this.state.map) {
      this.state.map.remove();
    }
  }

  renderFreguesias() {
    return freguesiasGEOJSON.features.map((freguesia, idx) => (
      <Polygon
        onclick={() =>
          this.props.selectFreguesiaFromMap(freguesia.properties.NOME)
        }
        key={`freguesia-${idx}`}
        positions={Turf.flip(Turf.toWgs84(freguesia)).geometry.coordinates}
        color={
          this.props.selectedFreguesia === freguesia.properties.NOME
            ? '#F77475'
            : '#55C5CF'
        }
      >
        <Popup>
          <div>
            <div>
              <strong>Projectos:</strong>
            </div>
            {this.props.queryResult
              ? this.props.queryResult.map((project) => {
                  if (project.FREGUESIA[0] === freguesia.properties.NOME) {
                    return (
                      <div style={{ fontSize: 10 }} key={project['Quem sou']}>
                        {project['Quem sou']}
                      </div>
                    );
                  }
                })
              : null}
            {'...'}

            <div>
              <strong>Freguesia:</strong>
            </div>
            <div style={{ fontSize: 10 }}>{freguesia.properties.NOME}</div>
          </div>
        </Popup>
      </Polygon>
    ));
  }

  renderMarkers() {
    //let arrayFreg = +;
    //  let freguesiasCount = this.props.queryResult ? this.props.queryResult : [];
    let distribution = (this.props.queryResult
      ? this.props.queryResult.map((project) => project['FREGUESIA'][0])
      : []
    ).reduce(
      (acum, cur) => Object.assign(acum, { [cur]: (acum[cur] | 0) + 1 }),
      {}
    );

    let counts = {}; //how much projects "per" freguesia
    if (this.props.queryResult) {
      let allFreguesias = [];
      this.props.queryResult.forEach((project) => {
        project['FREGUESIA'].forEach((freguesia) => {
          allFreguesias.push(freguesia);
        });
      });

      allFreguesias.forEach(function (x) {
        counts[x] = (counts[x] || 0) + 1;
      });
    }

    //console.log(distribution);

    return freguesiasGEOJSON.features.map(
      (freguesia, idx) => {
        // if (freguesia.properties.NOME === "Belém") {
        //   return null;
        // }

        if (this.props.selectedFreguesia === 'TODOS') {
          return (
            <Marker
              opacity={0}
              position={
                Turf.centroid(Turf.flip(Turf.toWgs84(freguesia))).geometry
                  .coordinates
              }
              key={idx}
            >
              <Tooltip
                className={
                  counts[freguesia.properties.NOME]
                    ? 'moreThanZero'
                    : 'noProjects'
                }
                permanent={true}
                sticky={true}
              >
                <div>
                  {/* <div className="markerFreguesiaCounter">
    {distribution[freguesia.properties.NOME]
      ? distribution[freguesia.properties.NOME]
      : 0}
  </div> */}
                  <div className="markerFreguesiaCounter">
                    {counts[freguesia.properties.NOME] && counts
                      ? counts[freguesia.properties.NOME]
                      : 0}
                  </div>
                </div>
              </Tooltip>
            </Marker>
          );
        } else {
          if (this.props.selectedFreguesia === freguesia.properties.NOME) {
            return (
              <Marker
                opacity={0}
                position={
                  Turf.centroid(Turf.flip(Turf.toWgs84(freguesia))).geometry
                    .coordinates
                }
                key={idx}
              >
                <Tooltip
                  className={
                    counts[freguesia.properties.NOME]
                      ? 'moreThanZero'
                      : 'noProjects'
                  }
                  permanent={true}
                  sticky={true}
                >
                  <div>
                    <div className="markerFreguesiaCounter">
                      {counts[freguesia.properties.NOME] && counts
                        ? counts[freguesia.properties.NOME]
                        : 0}
                    </div>
                  </div>
                </Tooltip>
              </Marker>
            );
          }
        }
      }

      // this.props.selectedFreguesia !== "TODOS" &&
      // this.props.selectedFreguesia === freguesia.properties.NOME ? (
    );
  }

  renderProjectCounterMarkers() {}

  renderPolygons() {
    console.log('Rendered polygon');
    return this.state.assetsOnMap.map((asset, idx) =>
      asset.geometry.type === 'Polygon' ? (
        <Polygon
          key={`polygon-${idx}`}
          positions={asset.geometry.coordinates}
          color={'#E91E63'}
        >
          <Popup>
            <span>{asset.properties.name}</span>
          </Popup>
        </Polygon>
      ) : null
    );
  }

  renderCircles() {
    return this.state.assetsOnMap.map((asset, idx) =>
      asset.geometry.type === 'Point' ? (
        <Circle
          key={`polygon-${idx}`}
          center={asset.geometry.coordinates}
          radius={10}
          color={'#E91E63'}
        >
          <Popup>
            <span>{asset.properties.name}</span>
          </Popup>
        </Circle>
      ) : null
    );
  }

  renderAllSelectedAssets() {
    /*
    .then(() => {
      this.setState({
        loadingDataOnMap: false
      });
    });*/
  }

  omg() {
    console.log('inside!');
  }
  renderPolygon(school) {
    //console.log("received:" + JSON.stringify(latLngList));
    return <Polygon positions={school} />;
  }

  render() {
    /*console.log(
      this.props.queryResult
        ? this.props.queryResult.map(project => project["FREGUESIA"])
        : null
    );
    console.log(this.props.queryResult);
*/
    var position = [this.state.lat, this.state.lng];
    var mapThemes = {
      stamenToner: {
        tiles: 'stamen-tiles-{s}.a.ssl.fastly.net/toner/',
        attribution:
          ' &copy; <a href=&quot;http://www.openstreetmap.org/copyright&quot;>OpenStreetMap contributors</a> &copy; <a href=&quot;http://cartodb.com/attributions&quot;>CartoDB</a>'
      },
      stamenTonerLite: {
        tiles: 'stamen-tiles-{s}.a.ssl.fastly.net/toner-lite/',
        attribution:
          ' &copy; <a href=&quot;http://www.openstreetmap.org/copyright&quot;>OpenStreetMap contributors</a> &copy; <a href=&quot;http://cartodb.com/attributions&quot;>CartoDB</a>'
      },
      stamenWatercolor: {
        tiles: 'stamen-tiles-{s}.a.ssl.fastly.net/watercolor/',
        attribution:
          ' &copy; <a href=&quot;http://www.openstreetmap.org/copyright&quot;>OpenStreetMap contributors</a> &copy; <a href=&quot;http://cartodb.com/attributions&quot;>CartoDB</a>'
      },
      cartoDark: {
        tiles: 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/dark_all/',
        attribution:
          ' &copy; <a href=&quot;http://www.openstreetmap.org/copyright&quot;>OpenStreetMap contributors</a> &copy; <a href=&quot;http://cartodb.com/attributions&quot;>CartoDB</a>'
      }
    };
    var current = mapThemes.stamenTonerLite;

    return (
      <Map
        center={position}
        zoom={this.state.zoom}
        scrollWheelZoom={false}
        touchZoom={true}
        dragging={true}
        tap={false}
      >
        <TileLayer
          attribution={current.attribution}
          url={`https://${current.tiles}{z}/{x}/{y}.png`}
        />
        {this.renderCircles()}
        {this.renderFreguesias()}
        {this.renderMarkers()}
      </Map>
    );
  }
}

const Map_Perform = useShallowEqual(_Map);

export default Map_Perform;
